import { render, staticRenderFns } from "./AssetInbox.vue?vue&type=template&id=a9cead00&scoped=true&"
import script from "./AssetInbox.vue?vue&type=script&lang=js&"
export * from "./AssetInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cead00",
  null
  
)

export default component.exports